import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import ExpenseForm from '../../components/Expense/ExpenseForm';
import { useExpense } from '../../store/expenseContext';
import { useParams, useNavigate } from 'react-router-dom';

const ExpenseFormPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { expenses, fetchExpenses } = useExpense();
    const [editExpense, setEditExpense] = useState<any | undefined>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        fetchExpenses();
    }, []);

    useEffect(() => {
        if (id) {
            const expense = expenses.find(r => r.id === id || r.id === id);
            setEditExpense(expense);
        } else {
            setEditExpense(undefined);
        }
    }, [id, expenses]);

    return (
        <div style={{ padding: 16 }}>
            <Card title={editExpense ? "Edit Expense" : "Add Expense"}>
                <ExpenseForm
                    editExpense={editExpense}
                    onFinishEdit={() => navigate('/expenses/list')}
                />
            </Card>
        </div>
    );
};

export default ExpenseFormPage;
